import { createEvent } from "effector"

export const clearStores = createEvent<void>()
